import "./CardsAdmin.css";
import React from "react";
import Card from 'react-bootstrap/Card';


function template({titre, icon, nombre, total, text, couleur}) {
  return (
    <div className="cards-admin py-2" >
      <Card style={{borderLeft: `5px solid ${couleur}`}}>
        <Card.Body>
          <div className="d-flex justify-content-between">
            <h5 className="text-uppercase">{titre}</h5>
            {icon}
          </div>
          
          <div>
            <span className="h1">{nombre}</span>
          </div>
          <div> <span>{total}</span>
          </div>
          <p> <strong style={{color: `${couleur}`}}>+ {nombre}  </strong>{text}</p>
        </Card.Body>
      </Card>
    </div>
  );
};

export default template;
